import React from 'react';
import { Text, FlexItem, Modal } from '@pairy/pds-react';
import { useInterval } from '@pairy/react-hooks';

import * as Styled from './index.styles';
import { tipInterval, tipTexts } from './index.constants';

const Loading = () => {
  const getRandomIndex = (prevIndex: number, length: number): number => {
    const randomIndex = Math.floor(Math.random() * length);
    if (randomIndex === prevIndex) {
      return getRandomIndex(prevIndex, length);
    }
    return randomIndex;
  };

  const [randomIndex, setRandomIndex] = React.useState<number>(
    Math.floor(Math.random() * tipTexts.length),
  );

  useInterval(() => {
    setRandomIndex((prev) => getRandomIndex(prev, tipTexts.length));
  }, tipInterval);

  return (
    <Styled.Wrapper>
      <Styled.StackInnerWrapper
        direction="column"
        alignItems="center"
        backgroundColor="transparent"
        gap={16}
      >
        <Styled.FlexTipWrapper alignItems="flex-end" justifyContent="center">
          <Styled.StackTipInnerWrapper
            direction="column"
            alignItems="center"
            gap={8}
          >
            <Text as="p" variant="xl-semibold" color="skyblue_500">
              Tip
            </Text>
            <Text
              as="p"
              variant="md-regular"
              color="skyblue_500"
              textAlign="center"
            >
              {tipTexts[randomIndex].map((text) => (
                <React.Fragment key={text}>
                  {text}
                  <br />
                </React.Fragment>
              ))}
            </Text>
          </Styled.StackTipInnerWrapper>
        </Styled.FlexTipWrapper>
        <FlexItem flexGrow={1}>
          <Modal.Spinner />
        </FlexItem>
      </Styled.StackInnerWrapper>
    </Styled.Wrapper>
  );
};

export default Loading;
